import React, { useState, useEffect } from "react";
import "./NewGame.css";

import { newGame, redicrectAuth } from "../../api";

const NewGame = ({}) => {
  if (redicrectAuth()) {
    window.location.href = "/";
  }

  const [bet, setBet] = useState("");
  const [error, setError] = useState("");
  const [insufficientFunds, setInsufficientFunds] = useState(false);
  const [publicGame, setPublicGame] = useState(true);
  const balance = localStorage.getItem("balance");

  const handleCheckboxChange = () => {
    setPublicGame(!publicGame);
  };

  const handleBetChange = (e) => {
    if (/^\d*$/.test(e.target.value)) {
      setBet(e.target.value);
    }
    setInsufficientFunds(false);
    setError("");
  };

  const handleJoin = (gameId) => {
    window.location.href = `/game/${gameId}`;
  };

  const handleStartGame = async () => {
    if (!bet || isNaN(bet) || Number(bet) <= 0) {
      setError("Enter valid bet");
      return;
    }

    if (Number(balance) < Number(bet)) {
      setInsufficientFunds(true);
      setError("Insufficient funds");
      return;
    }

    newGame(bet, publicGame, handleJoin, setError);
  };

  const back = () => {
    window.location.href = `/menu`;
  };

  const deposit = () => {
    window.location.href = `/walletop`;
  };

  return (
    <div>
      <div className="container2">
        <button className="backbutton" onClick={back}>
          <img className="imagebackbutton" src="/home.svg" alt="Home" />
        </button>
        <div className="balance-text2">{parseFloat(balance).toFixed(2)}</div>
      </div>
      <div className="input-title">Bet</div>
      {error && <div className="error-title">{error}</div>}
      <div className="input-amount">
        <img className="icon2" src="/ton.png" alt="Icon" />
        <input
          className="input-amount-input"
          onChange={handleBetChange}
          value={bet}
          type="number"
        />
      </div>
      <label className="custom-checkbox">
        <input
          type="checkbox"
          checked={publicGame}
          onChange={handleCheckboxChange}
        />
        <span className="checkmark"></span>
        <span className="checkbox-title">Public Game</span>
      </label>
      {insufficientFunds ? (
        <div>
          <div className="create-container">
            <button className="create-button" onClick={deposit}>
              Deposit
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div className="create-container">
            <button className="create-button" onClick={handleStartGame}>
              Create
            </button>
          </div>
          <div className="note-text-subtitle">
            Please be aware that 10% of your bet will be taken as a fee
          </div>
        </div>
      )}
    </div>
  );
};

export default NewGame;
